<template>
  <div style="width:100%;">
    <headNavBar title="消息提醒" />
    <van-cell-group style="display:none">
      <van-switch-cell
        v-for="(item, index) in data"
        :key="index"
        v-model="item.switch"
        :title="item.label"
        style="font-size:0.4rem;"
        active-color="rgb(77,217,99)"
        size="24px"
      />
    </van-cell-group>
  </div>
</template>
<script>
import { CellGroup, SwitchCell } from "vant";
export default {
  porps: {},
  data() {
    return {
      data: [],
    };
  },
  components: {
    [CellGroup.name]: CellGroup,
    [SwitchCell.name]: SwitchCell,
  },
  created() {
    this.data = [
      {
        label: "订单消息",
        switch: true,
      },
      {
        label: "房态消息",
        switch: false,
      },
      {
        label: "入住消息",
        switch: false,
      },
      {
        label: "其他消息",
        switch: false,
      },
    ];
  },
};
</script>
